import { LINKS } from "./links";

export type FooterLink = { label: string; href: string };
export type FooterColumn = { title: string; links: FooterLink[] };

export const FOOTER_COLUMNS: FooterColumn[] = [
  {
    title: "Product",
    links: [
      { label: "A day with Sidestack", href: "#a-day" },
      { label: "What it does", href: "#what" },
      { label: "How it works", href: "#how" },
      { label: "Privacy", href: "#privacy" },
      { label: "Pricing", href: "#pricing" },
    ],
  },
  {
    title: "Trust",
    links: [
      { label: "Trust doc", href: LINKS.trust },
      { label: "Privacy policy", href: LINKS.privacy },
      { label: "Terms", href: LINKS.terms },
    ],
  },
  {
    title: "Connect",
    links: [
      { label: "Book a setup call", href: LINKS.setup },
      { label: "X / @try_sidestack", href: LINKS.x },
    ],
  },
];

export const NAV_LINKS: FooterLink[] = [
  { label: "A day", href: "#a-day" },
  { label: "Automations", href: "#automations" },
  { label: "Privacy", href: "#privacy" },
  { label: "Pricing", href: "#pricing" },
];

// Single source of truth for "should this open in a new tab?" — used by every
// link renderer in the footer so the same href can't behave two different ways.
// Absolute URLs and mailto/tel open in a new tab; in-page anchors (#…) and
// same-origin paths (/terms.html, /privacy.html) stay in the current tab so
// the browser handles them natively. The trust doc lives at a Google Docs URL
// (LINKS.trust) and therefore opens in a new tab via this same rule.
export function isExternalHref(href: string): boolean {
  return /^(https?:|mailto:|tel:)/i.test(href);
}
